import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { BookingSerializer } from './booking.serializer'

@Injectable()
export class BookingDocumentService {
  // TODO create some resource service to extend that works for services like this
  constructor(
    private http: HttpClient,
    private serializer: BookingSerializer
  ) {}

  public createOne(bookingId: number, documentId: number): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-document`,
      { bookingId, documentId }
    )
  }

  public deleteOne(bookingId: number, documentId: number): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/bookings/${bookingId}/booking-document/${documentId}`
    )
  }
}
